import { useState } from "react";
import MainCalculatorsList from "../OtherCalculator/CountriesMainCalculatorsList/SAMainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة النطاقات - حساب مستوى التوطين في السعودية";
const DESCRIPTION = "حاسبة نطاقات تساعدك على تحديد مستوى توطين المنشأة وفقاً لبرنامج نطاقات التابع لوزارة الموارد البشرية والتنمية الاجتماعية في السعودية";
const KEYWORDS = "حاسبة نطاقات, حساب التوطين, نسبة التوطين, نطاقات, بلاتيني, أخضر, أحمر, وزارة الموارد البشرية, السعودية, العمالة, العمالة الوافدة";
const OG_URL = "https://do-calculate.com/calculator/ar/countries/SA/calculators-list/nitaqat-calculator/";
function NitaqatCalculator() {
  const [saudiEmployees, setSaudiEmployees] = useState("");
  const [nonSaudiEmployees, setNonSaudiEmployees] = useState("");
  const [showSpecialCases, setShowSpecialCases] = useState(false);
  const [specialCases, setSpecialCases] = useState({
    disabled: 0,
    students: 0,
    partTime: 0,
    palestinians: 0
  });
  const [nitaqatLevel, setNitaqatLevel] = useState(null);
  const [error, setError] = useState("");
  const calculateNitaqatLevel = () => {
    try {
      setError("");
      if (!saudiEmployees || !nonSaudiEmployees) {
        throw new Error("الرجاء إدخال جميع البيانات المطلوبة");
      }
      const saudis = parseInt(saudiEmployees);
      const nonSaudis = parseInt(nonSaudiEmployees);
      const total = saudis + nonSaudis;
      const {
        disabled,
        students,
        partTime,
        palestinians
      } = specialCases;
      if (disabled > saudis || students > saudis || partTime > saudis) {
        throw new Error("عدد الحالات الخاصة لا يمكن أن يكون أكبر من عدد السعوديين الأساسي");
      }
      if (palestinians > nonSaudis) {
        throw new Error("عدد الفلسطينيين لا يمكن أن يكون أكبر من عدد غير السعوديين الأساسي");
      }
      const adjustedSaudis = (saudis - disabled - students - partTime) +
        (disabled * 4) +
        (students * 0.5) +
        (partTime * 0.5);
      const adjustedForeigners = nonSaudis -
        (palestinians * 0.75);
      const adjustedTotal = adjustedSaudis + adjustedForeigners;
      const localizationPercentage = (adjustedSaudis / adjustedTotal) * 100;
      let level, color;
      if (total <= 5) {
        level = adjustedSaudis >= 1 ? "أخضر" : "أحمر";
        color = adjustedSaudis >= 1 ? "green" : "red";
      } else {
        if (localizationPercentage >= 40) {
          level = "بلاتيني";
          color = "primary";
        } else if (localizationPercentage >= 30) {
          level = "الأخضر العالي";
          color = "success";
        } else if (localizationPercentage >= 20) {
          level = "الأخضر المتوسط";
          color = "success";
        } else if (localizationPercentage >= 10) {
          level = "الأخضر المنخفض";
          color = "success";
        } else {
          level = "أحمر";
          color = "danger";
        }
      }
      setNitaqatLevel({
        level,
        color,
        percentage: localizationPercentage.toFixed(2),
        adjustedSaudis: adjustedSaudis.toFixed(2),
        adjustedForeigners: adjustedForeigners.toFixed(2),
        totalEmployees: total
      });
    } catch (error) {
      setError(error.message);
    }
  };
  const handleSpecialCaseChange = (field, value) => {
    setSpecialCases(prev => ({
      ...prev,
      [field]: parseInt(value) || 0
    }));
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="p-3">
                <p className="lead">
                  مرحبًا بك في حاسبة نطاقات الرسمية - الأداة الأكثر دقة لتحديد مستوى توطين منشأتك وفقًا لبرنامج نطاقات التابع لوزارة الموارد البشرية والتنمية الاجتماعية في المملكة العربية السعودية.
                </p>
                <b >تعليمات الاستخدام:</b>
                <p>
                  تتيح لك هذه الحاسبة تحديد نطاق منشأتك بدقة من خلال:
                </p>
                <ol>
                  <li>إدخال العدد الأساسي للموظفين السعوديين وغير السعوديين</li>
                  <li>تحديد الحالات الخاصة إن وجدت (ذوي الاحتياجات الخاصة، الطلاب، دوام جزئي، إلخ)</li>
                  <li>الحصول على نتيجة فورية تبين نطاق منشأتك (بلاتيني، أخضر، أحمر) وتأثير ذلك على خدمات الوزارة</li>
                </ol>
                <hr />
                <p className="mb-0 alert alert-info">
                  <strong>ملاحظة:</strong> المنشآت الصغيرة (5 موظفين أو أقل) لها نطاقان فقط: أخضر (بوجود موظف سعودي واحد على الأقل) أو أحمر.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group">
                    <label>عدد الموظفين السعوديين:</label>
                    <input
                      type="number"
                      value={saudiEmployees}
                      onChange={(e) => setSaudiEmployees(e.target.value)}
                      className="form-control mb-2"
                      placeholder="أدخل العدد الكلي للسعوديين"
                    />
                  </div>
                  <div className="form-group">
                    <label>عدد الموظفين غير السعوديين:</label>
                    <input
                      type="number"
                      value={nonSaudiEmployees}
                      onChange={(e) => setNonSaudiEmployees(e.target.value)}
                      className="form-control mb-2"
                      placeholder="أدخل العدد الكلي لغير السعوديين"
                    />
                  </div>
                  <hr />
                  <div style={{ marginBottom: "10px" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={showSpecialCases}
                        onChange={() => setShowSpecialCases(!showSpecialCases)}
                      />
                      لدي حالات خاصة للموظفين
                    </label>
                  </div>
                  {showSpecialCases && (
                    <div className="border p-3 mb-3 bg-light">
                      <h5 style={{ fontSize: "14px" }} className="bg-success text-white">الحالات الخاصة:</h5>
                      <p className="text-muted small mb-3">يجب أن يكون هؤلاء الموظفون مضافين في الأعداد الأساسية أعلاه</p>
                      <div className="form-group">
                        <label>السعوديون ذوو الاحتياجات الخاصة:</label>
                        <input
                          type="number"
                          value={specialCases.disabled}
                          onChange={(e) => handleSpecialCaseChange("disabled", e.target.value)}
                          className="form-control mb-2"
                          placeholder="يتم احتساب كل واحد كـ 4 سعوديين"
                        />
                        <small className="text-muted">يجب أن يكون العدد ≤ عدد السعوديين</small>
                      </div>
                      <div className="form-group">
                        <label>السعوديون الطلاب:</label>
                        <input
                          type="number"
                          value={specialCases.students}
                          onChange={(e) => handleSpecialCaseChange("students", e.target.value)}
                          className="form-control mb-2"
                          placeholder="يتم احتسابهم بنصف سعودي"
                        />
                        <small className="text-muted">يجب أن يكون العدد ≤ عدد السعوديين</small>
                      </div>
                      <div className="form-group">
                        <label>السعوديون بدوام جزئي:</label>
                        <input
                          type="number"
                          value={specialCases.partTime}
                          onChange={(e) => handleSpecialCaseChange("partTime", e.target.value)}
                          className="form-control mb-2"
                          placeholder="يتم احتسابهم بنصف سعودي"
                        />
                        <small className="text-muted">يجب أن يكون العدد ≤ عدد السعوديين</small>
                      </div>
                      <div className="form-group">
                        <label>الفلسطينيون الحاملون للجواز المصري:</label>
                        <input
                          type="number"
                          value={specialCases.palestinians}
                          onChange={(e) => handleSpecialCaseChange("palestinians", e.target.value)}
                          className="form-control mb-2"
                          placeholder="يتم احتسابهم بربع وافد"
                        />
                        <small className="text-muted">يجب أن يكون العدد ≤ عدد غير السعوديين</small>
                      </div>
                    </div>
                  )}
                  <br />
                  <button
                    className="text-white bg-success btn-lg"
                    onClick={calculateNitaqatLevel}
                  >
                    احسب مستوى النطاق
                  </button>
                </div>
                {error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  nitaqatLevel !== null && (
                    <div className={`p-3 mb-2 bg-info `}>
                      <h3>نتيجة الحساب:</h3>
                      <p>إجمالي الموظفين: {nitaqatLevel.totalEmployees}</p>
                      <p>نسبة التوطين المعدلة: {nitaqatLevel.percentage}%</p>
                      <p>عدد السعوديين بعد التعديل: {nitaqatLevel.adjustedSaudis}</p>
                      <p>عدد غير السعوديين بعد التعديل: {nitaqatLevel.adjustedForeigners}</p>
                      <p>مستوى النطاق: <strong>{nitaqatLevel.level}</strong></p>
                      {nitaqatLevel.totalEmployees <= 5 && (
                        <div className="mt-2 p-2 bg-info text-dark">
                          <small>
                            ملاحظة: المنشآت الصغيرة (5 موظفين أو أقل) لها نطاقان فقط: أخضر (سعودي واحد على الأقل) أو أحمر
                          </small>
                        </div>
                      )}
                    </div>
                  )
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">كيفية استخدام الحاسبة خطوة بخطوة</div>
              <div className="info-section-body">
                <div >
                  <h4>طريقة الإدخال الصحيحة:</h4>
                  <ol>
                    <li><strong>أدخل العدد الكلي للموظفين السعوديين</strong> في الحقل المخصص (يشمل جميع السعوديين بغض النظر عن حالتهم)</li>
                    <li><strong>أدخل العدد الكلي للموظفين غير السعوديين</strong> في الحقل المخصص (يشمل جميع غير السعوديين بغض النظر عن حالتهم)</li>
                    <li><strong>فعّل خيار "لدي حالات خاصة"</strong> إذا كان لديك موظفون في أي من الحالات الخاصة المذكورة أدناه</li>
                    <li><strong>أدخل أعداد كل حالة خاصة</strong> في الحقول التي ستظهر (سيتم حسابها تلقائيًا وفق أنظمة نطاقات)</li>
                    <li><strong>اضغط على "احسب مستوى النطاق"</strong> للحصول على النتيجة الفورية</li>
                  </ol>
                </div>
                <div className="mt-4">
                  <h5>مثال تطبيقي شامل:</h5>
                  <p>لنفترض أن لديك منشأة بها:</p>
                  <ul className="list-group mb-3">
                    <li className="list-group-item">
                      <strong>8 موظفين سعوديين</strong> منهم:
                      <ul>
                        <li>2 من ذوي الاحتياجات الخاصة</li>
                        <li>3 طلاب</li>
                        <li>1 بدوام جزئي</li>
                      </ul>
                    </li>
                    <li className="list-group-item">
                      <strong>12 موظف غير سعودي</strong> منهم:
                      <ul>
                        <li>4 فلسطينيون حاملون للجواز المصري</li>
                      </ul>
                    </li>
                  </ul>
                  <p>كيفية الإدخال:</p>
                  <ul className="list-group">
                    <li className="list-group-item">عدد السعوديين: 8</li>
                    <li className="list-group-item">عدد غير السعوديين: 12</li>
                    <li className="list-group-item">تفعيل خيار الحالات الخاصة</li>
                    <li className="list-group-item">
                      إدخال الحالات الخاصة:
                      <ul>
                        <li>ذوي الاحتياجات الخاصة: 2</li>
                        <li>الطلاب: 3</li>
                        <li>دوام جزئي: 1</li>
                        <li>الفلسطينيون: 4</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">معلومات شاملة عن برنامج نطاقات</div>
              <div className="info-section-body">
                <div className="mb-4">
                  <h4>ما هو برنامج نطاقات؟</h4>
                  <p>
                    نطاقات هو البرنامج الوطني لتوطين الوظائف في المملكة العربية السعودية، الذي تنفذه وزارة الموارد البشرية والتنمية الاجتماعية. يهدف البرنامج إلى:
                  </p>
                  <ul>
                    <li>زيادة فرص العمل للمواطنين السعوديين</li>
                    <li>تصنيف المنشآت حسب نسبة التوطين</li>
                    <li>تحفيز المنشآت على توظيف السعوديين</li>
                    <li>تنظيم سوق العمل وفق رؤية المملكة 2030</li>
                  </ul>
                </div>
                <div className="mb-4">
                  <h4>تصنيف النطاقات ومميزاتها</h4>
                  <table >
                    <thead className="table-success">
                      <tr>
                        <th>النطاق</th>
                        <th>نسبة التوطين</th>
                        <th>المميزات</th>
                        <th>القيود</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="table-primary">
                        <td>البلاتيني</td>
                        <td>40% فأكثر</td>
                        <td>أعلى المميزات، أولوية في الخدمات</td>
                        <td>لا يوجد</td>
                      </tr>
                      <tr className="table-success">
                        <td>الأخضر العالي</td>
                        <td>30% فأكثر</td>
                        <td>تجديد الرخص، تأشيرات جديدة، نقل كفالة</td>
                        <td>لا يوجد</td>
                      </tr>
                      <tr className="table-success">
                        <td>الأخضر المتوسط</td>
                        <td>20% فأكثر</td>
                        <td>تجديد الرخص، تأشيرات محدودة</td>
                        <td>قيود على بعض الخدمات</td>
                      </tr>
                      <tr className="table-success">
                        <td>الأخضر المنخفض</td>
                        <td>10% فأكثر</td>
                        <td>تجديد الرخص للعمالة الحالية</td>
                        <td>لا يسمح بتأشيرات جديدة</td>
                      </tr>
                      <tr className="table-danger">
                        <td>الأحمر</td>
                        <td>أقل من 10%</td>
                        <td>لا يوجد</td>
                        <td>عدم القدرة على تجديد الرخص أو طلب تأشيرات جديدة</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="mb-4">
                  <h4>العوامل المؤثرة في تصنيف النطاق</h4>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="card h-100">
                        <div className="card-body">
                          <h5 className="card-title">النشاط الاقتصادي</h5>
                          <p className="card-text">
                            يختلف نسبة التوطين المطلوبة حسب النشاط الاقتصادي للمنشأة كما تحددها الوزارة
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="card h-100">
                        <div className="card-body">
                          <h5 className="card-title">حجم المنشأة</h5>
                          <p className="card-text">
                            عدد الموظفين الإجمالي يحدد طريقة حساب النطاق (خاصة للمنشآت الصغيرة ≤5 موظفين)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="card h-100">
                        <div className="card-body">
                          <h5 className="card-title">نسبة التوطين</h5>
                          <p className="card-text">
                            عدد السعوديين مقارنة بغير السعوديين مع مراعاة الحالات الخاصة
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">الحالات الخاصة وتأثيرها على حساب النطاق</div>
              <div className="info-section-body">
                <div className="mb-4">
                  <h4>حالات تزيد من نسبة التوطين</h4>
                  <div className="card border-success mb-3">
                    <div className="card-header bg-success text-white">موظفون يحسبون بأكثر من سعودي واحد</div>
                    <div className="card-body">
                      <ul>
                        <li>
                          <strong>ذوو الاحتياجات الخاصة:</strong> يحسب كل موظف كـ 4 سعوديين (بحد أقصى 10% من إجمالي الموظفين)
                        </li>
                        <li>
                          <strong>ذوو السوابق والمفرج عنهم:</strong> يحسب كل موظف كـ 2 سعوديين (بحد أقصى 10% من الإجمالي)
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="mb-4">
                  <h4>حالات تقلل من نسبة التوطين</h4>
                  <div className="card border-warning mb-3">
                    <div className="card-header bg-warning text-dark">موظفون يحسبون بأقل من سعودي واحد</div>
                    <div className="card-body">
                      <ul>
                        <li>
                          <strong>الطلاب:</strong> يحسب كل موظف بنصف سعودي (بحد أقصى 10% من الإجمالي، 40% لقطاع الأغذية)
                        </li>
                        <li>
                          <strong>دوام جزئي:</strong> يحسب كل موظف بنصف سعودي
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="mb-4">
                  <h4>حالات خاصة للوافدين</h4>
                  <div className="card border-info mb-3">
                    <div className="card-header bg-info text-black">وافدون يحسبون بأقل من وافد واحد</div>
                    <div className="card-body">
                      <ul>
                        <li>
                          <strong>الفلسطينيون الحاملون للجواز المصري:</strong> يحسب كل 4 موظفين كوافد واحد (بحد أقصى 50% من الإجمالي)
                        </li>
                        <li>
                          <strong>البرماويون:</strong> يحسب كل 4 موظفين كوافد واحد (في جميع المناطق except مكة والمدينة)
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="alert alert-secondary">
                  <h5>حالات أخرى مهمة:</h5>
                  <ul>
                    <li>الموظفون عن بُعد يحسبون كسعودي واحد</li>
                    <li>أبناء وبنات المواطنات يحسبون كسعودي واحد</li>
                    <li>أمهات وأرامل المواطنين يحسبن كسعودية واحدة</li>
                    <li>مواطنو دول الخليج يحسبون كسعوديين</li>
                    <li>المالك يحسب كسعودي واحد</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default NitaqatCalculator;